import { gql } from '@apollo/client';
import { useMutation } from '../hooks';

const emailTemplateFields = gql`
  fragment EmailTemplateFields on EmailTemplate {
    name
    body
    kind
    reminderDays
    reminderDirection
    reminderEventState
    reminderOccasion
    enabled
    documents {
      id
      filename
      byteSize
      url
    }
    eventTypeNames
  }
`;

const updateMutaion = gql`
  mutation UpdateEmailTemplate($input: UpdateEmailTemplateInput!) {
    updateEmailTemplate(input: $input) {
      emailTemplate {
        id
        ...EmailTemplateFields
      }
      errors {
        message
      }
    }
  }
  ${emailTemplateFields}
`;

export const useUpdateEmailTemplateMutation = (config) =>
  useMutation(updateMutaion, config);
